module.exports = __webpack_public_path__ + "img/Apple - AirPods Pro 2.55e84ee7.jpg";